import { LABEL_QUEST, LABEL_QUEST_IMG } from "../constants.js";
import { createImagePicker } from "../imagePicker.js";

export function structureInfo(id) {
  return `
        <div>
            <div class="title-box">
                <div class="title-text"><i class="bi bi-info-circle"></i> Infotext/-bild</div>
                <button type="button" class="btn-node-delete" title="Element entfernen" aria-label="Element entfernen"><i class="bi bi-x-lg"></i></button>
            </div>
            <hr>
            <div class="content-box">
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">${LABEL_QUEST}</label>
                        <div class="col-12">
                            <textarea class="form-control form-control-sm" style="height: 100px;" df-text></textarea>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <label class="col-12">${LABEL_QUEST_IMG}</label>
                        <div class="col-12">
                            ${createImagePicker(id, "frageimg", "df-frageimg")}
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
}
